import {Spin, Modal, Typography, Button} from 'antd'
import './index.less'
import action from "../../../../store/action";
import {connect} from "react-redux";
import React,{useEffect, useState} from 'react'
const { Link } = Typography

function StageParameterErrorModal(props) {

    const { stageErrorModalVisible, setStageErrorModalVisible } = props

    const handleCancel = () => {
      setStageErrorModalVisible(false)
    }

    return (
        <>
            {
                stageErrorModalVisible ? (
                    <Modal 
                      width={600}
                      open={stageErrorModalVisible} 
                      title={<div className='modal-title'>Please Check the Stages</div>} 
                      footer={
                        <div className="footer-buttons">
                          <Button type="primary" onClick={handleCancel}>
                            OK
                          </Button>
                        </div>
                      } 
                      mask={false} 
                      centered 
                      onCancel={handleCancel}
                    >
                        <div className="modal-container">
                          <div className="tip-text">
                            Corruption in staging parameters has been detected. The stages may
                            differ from those in the Desktop App.
                          </div>
                          <div className="support-text">
                            If you notice differences, please refer to&nbsp;
                            <Link
                              href="https://support.archform.com/Staging-Parameter-Corruption-1ade0b3b589f80168bcdda1666f3f2f4"
                              target="_blank"
                              className="af-sharable-link"
                            >
                              <span>
                                Staging Parameter Corruption
                              </span>
                            </Link>
                            to correct the case.
                          </div>
                        </div>
                    </Modal>
                ) : <></>
            }
        </>
    );
}

const mapStateToProps = state => ({
  stageErrorModalVisible: state.webViewer.stageErrorModalVisible
})

const mapDispatchToProps = dispatch => ({
    setStageErrorModalVisible: val => dispatch(action.setStageErrorModalVisible(val)),
})

export default connect(mapStateToProps, mapDispatchToProps)(StageParameterErrorModal);
